import { Box, Typography } from "@mui/material"
import { FC } from "react";
import Moment from "../Moment/Moment";
import styles from './ReadReviewDialog.module.scss';

interface ICommentedBy{
    avatar: string,
    name: string
}

interface IComment{
    commentedAt: string,
    comment: string,
    commentedBy: ICommentedBy,
}

interface IComments{
    comments: Array<IComment>
}

const Comment: FC<any> = (props): JSX.Element => {
    const {comments} = props;
  return (
    <>
     {
        comments?.map((c:IComment) => {
            return (
                <li key={c.commentedAt}>
                <Box className={`d-flex`}>
                    <Box className={`avatar rounded avatar-40 mg-r-8 mg-t-5`}>
                        <img className={`img-fluid`} src={c?.commentedBy?.avatar || ""} alt="profile"/>
                    </Box>
                    <Box className={`${styles.commentBox}`}>
                        <Box className={`d-flex flex-wrap align-items-center`}>
                            <Typography variant={"body1"} className={`font-weight-medium font-size-sm mg-r-10`}>{c.commentedBy.name}</Typography>
                            <Typography variant={"body1"} className={`${styles.fontSize11} mg-t-2`} color={"secondary"}><Moment date={c.commentedAt} format="h:mm A, MMM DD, YYYY"/></Typography>
                        </Box>
                        <Typography variant={"body1"} className={`font-size-sm`} color={"secondary"}>{c.comment}</Typography>
                    </Box>
                </Box>
            </li>
            )
        })
    }
    </>
  )
}

export default Comment